module.exports = __webpack_public_path__ + "assets/business-hour-black.59e35378.svg";